module.exports = __webpack_public_path__ + "static/media/background.f946e336.png";